import _ from 'lodash';
import React from 'react';
import { Translate } from '../../../../components/translate/translate';
import { JobStatus } from '../../../../redux/jobs/jobs.types';
import { MaybeUndef } from '../../../../types/system';
import { memoizedPartial } from '../../../../utils/function/memoized-partial';
import { AccordionItemContainer } from '../../accordion/accordion-item/accordion-item';
import { OperationRow } from '../../operations-table/operation-row/operation-row';
import { JobBasedOperation } from '../common/compress/job-based-group.types';
import { jobStatusToGenericOperationStatus } from '../common/utils/status.utils';
import styles from './compress-group.scss';

function getTitle(operation: JobBasedOperation): React.ReactNode {
  switch (operation.status) {
    case undefined:
    case JobStatus.PENDING:
    case JobStatus.WORKING:
      return (
        <Translate
          transKey="operation-panel.compress.title.downloading"
          params={{ count: operation.filesNumber }}
        />
      );

    case JobStatus.SUCCESS:
      return <Translate transKey="operation-panel.compress.title.complete" />;

    case JobStatus.ERROR:
    default:
      return <Translate transKey="operation-panel.compress.title.error" />;
  }
}

function getLocateHandler(
  locateFile: (fileId: string) => void,
  operation: JobBasedOperation,
): MaybeUndef<() => void> {
  if (operation.status !== JobStatus.SUCCESS || !operation.job) {
    return;
  }

  const fileId = _.get(operation.job.result, 'payload.id');

  return typeof fileId === 'string'
    ? memoizedPartial(locateFile, fileId)
    : undefined;
}

export interface OwnProps {
  groupId: string;
}

export interface StateProps {
  operation: JobBasedOperation;
}

export interface DispatchProps {
  closeGroup(groupId: string): void;
  locateFile(fileId: string): void;
}

type Props = OwnProps & StateProps & DispatchProps;

export const CompressGroup: React.FunctionComponent<Props> = ({
  groupId,
  operation,
  closeGroup,
  locateFile,
}: Props) => {
  return (
    <AccordionItemContainer
      id={groupId}
      title={getTitle(operation)}
      onCloseClick={memoizedPartial(closeGroup, groupId)}
    >
      <OperationRow
        thumb={<div className={styles.zippingThumb} />}
        name={
          <Translate
            transKey="operation-panel.common.zipping-operation-name"
            params={{ count: operation.filesNumber }}
          />
        }
        size={operation.filesSize}
        status={jobStatusToGenericOperationStatus(operation.status)}
        onLocateClick={getLocateHandler(locateFile, operation)}
      />
    </AccordionItemContainer>
  );
};
